"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 *
 *@description:
 *@modifyContent: 密码校验逻辑
 *@author: qiuhongyang
 *@date: 2020-08-03 14:41:57
 *
*/
var dot_1 = __importDefault(require("dot"));
var getaccesstk_1 = __importDefault(require("../langke/getaccesstk"));
var cookie_1 = __importDefault(require("../cookie"));
var user_1 = __importDefault(require("../user"));
var pwhtml = require('./inputpw.html');
var errhtml = require('./error.html');
function keyupFun(target, e) {
    var k = e.keyCode;
    var val = e.key;
    if (k == 8) { //8是backspace的keyCode
        target.prev().find('input').focus();
    }
    else {
        return false;
    }
}
var isfirst = false;
var checkauth = {
    options: {
        curuid: '',
        channel_id: '',
        view_type: '',
        code: '',
        notice: '',
        access_token: '',
        subpwfun: function () { } //校验成功后回调
    },
    show: function (opt) {
        var that = this;
        that.options = $.extend({}, that.options, opt);
        // $("#ly-pop-modal").remove()
        var htmlstr = dot_1.default.template(pwhtml);
        //密码上线提示
        if (that.options.code == '6010') {
            var o = {
                tipinfo: that.options.notice || ""
            };
            htmlstr = dot_1.default.template(errhtml)(o);
        }
        ;
        $("#mian-content-wrap").append(htmlstr);
        setTimeout(function () {
            that.bindenvent();
        }, 500);
    },
    //错误事件及其它
    errfun: function (data) {
        var that = this;
        $("#ly-pop-errmodal").remove();
        //let errelstr = type == 'limiterr' ? limiterrhtml : errhtml;  //输入次数 or 输入错误提示
        var htmlstr = dot_1.default.template(errhtml)(data);
        $("#mian-content-wrap").append(htmlstr);
        $("#ly-btn-resub").on('click', function () {
            $("#ly-pop-modal").find('input[name="lypw"]').val("");
            $("#lysubmit").find('input').first().focus();
            $("#ly-pop-errmodal").remove();
        });
        $(".ly-btn-cancel").on('click', function () {
            $("#ly-pop-errmodal").remove();
        });
    },
    checklogin: function () {
        //获取用户
        var userinfo = user_1.default.get();
        if (userinfo == null) {
            window.open("https://passport2.eastmoney.com/pub/login?backurl=" + encodeURIComponent(self.location.href));
            return false;
        }
    },
    bindenvent: function () {
        var that = this;
        if (isfirst)
            return;
        isfirst = true;
        var modalDom = $("#ly-pop-modal");
        $("#ly-btn-sub").on('click', function () {
            that.checklogin();
            var str = [].map.call(modalDom.find('input[name="lypw"]'), function (item, index) { return $(item).val(); });
            var pw = str.join('');
            if (!pw)
                return;
            that.submitpw(pw);
        });
        $(".ly-btn-cancel").on('click', function () {
            modalDom.remove();
        });
        //焦点事件
        $("#lysubmit").find('input').first().focus();
        modalDom.on('input propertychange', '.item', function () {
            var ipdom = $(this).find('input');
            var reg = new RegExp("^[0-9]*$");
            var val = ipdom.val();
            if (!reg.test(val)) {
                ipdom.val('');
            }
            ;
            if ($(this).find('input').val() !== "") {
                $(this).next().find('input').focus();
            }
        });
        //监听backspace事件
        modalDom.on("keyup", ".item", function (e) {
            keyupFun($(this), e);
        });
    },
    //密码提交判断
    submitpw: function (pw) {
        return __awaiter(this, void 0, void 0, function () {
            var that, validateinfo, obj, obj, lyanthstr;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        that = this;
                        return [4 /*yield*/, that.gettkinfos(pw)];
                    case 1:
                        validateinfo = _a.sent();
                        that.options.access_token = validateinfo === null || validateinfo === void 0 ? void 0 : validateinfo.access_token;
                        //密码次数控制
                        if ((validateinfo === null || validateinfo === void 0 ? void 0 : validateinfo.code) == 6010) {
                            obj = {
                                tipinfo: (validateinfo === null || validateinfo === void 0 ? void 0 : validateinfo.notice) || '当日密码输入次数超限',
                                errtype: 'limiterr'
                            };
                            that.errfun(obj);
                            return [2 /*return*/, false];
                        }
                        ;
                        //认证不通过或密码错误
                        if (!(validateinfo === null || validateinfo === void 0 ? void 0 : validateinfo.access_token) || (validateinfo === null || validateinfo === void 0 ? void 0 : validateinfo.code) == 6100) {
                            obj = {
                                tipinfo: '密码错误',
                                errtype: 'ipterr'
                            };
                            that.errfun(obj);
                            return [2 /*return*/, false];
                        }
                        ;
                        lyanthstr = (new Date()).getTime() + '_' + that.options.curuid + '_' + urlid;
                        cookie_1.default.set('ly_hasauth_tk', lyanthstr, 1);
                        that.options.subpwfun(); // 成功后回调函数
                        $("#ly-pop-modal").remove();
                        $("#ly-pop-errmodal").remove();
                        return [2 /*return*/];
                }
            });
        });
    },
    gettkinfos: function (pw) {
        return __awaiter(this, void 0, void 0, function () {
            var that, obj;
            return __generator(this, function (_a) {
                that = this;
                obj = {
                    channel_id: that.options.channel_id,
                    password: pw,
                    view_type: 1
                };
                // let validateinfos = await getaccesstk(obj);
                return [2 /*return*/, (0, getaccesstk_1.default)(obj)];
            });
        });
    }
};
exports.default = checkauth;
//# sourceMappingURL=data:application/json;base64,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